import React, { useEffect } from 'react';
import { loadAllClients, selectClient } from '../clients/clientsSlice';
import { useAppDispatch } from '../hooks';

interface IProps {
  clientAbbr: string
  clientName: string
  defaultDashboard: number
  toggleDashboardModal: () => void;
  clearSearch: any;
}

export function DashboardSelectorComponent(props: IProps) {
  const { clientAbbr, clientName, defaultDashboard, toggleDashboardModal, clearSearch } = props;
  const dispatch = useAppDispatch();
  useEffect(() => {
    //init JsTree elements
    setupDashboardTrees(clientAbbr, defaultDashboard);
  }, [])
  return (
    <div id="modifyDashboardsModal">
      <div id="modifyDashboardsModalFormz">
        <div className="modal-content">
          <h4>Choose Dashboards for {clientName} <small className="small grey-text">({clientAbbr})</small></h4>
          <h6
            id="dash_error_message"
            style={{ display: 'none', fontStyle: 'italic', color: 'red' }}
          >
            You must choose at least one access dashboard and one default
            dashboard.
          </h6>
          <div className="row" style={{ padding: '5px' }}>
            <div className="col s6">
              <span>
                <b>Which dashboards can they view?</b>
              </span>
            </div>
            <div className="col s6">
              <span>
                <b>Which dashboard do they visit first after logging in?</b>
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col s6">
              <div id="dashboardAccessTree"></div>
              <input
                type="text"
                id="dashboardAccessTree_validate"
                style={{ height: '1px', margin: '0', border: '0' }}
                name="s_dashboardAccessTree_validate"
                required
              />
            </div>
            <div className="col s6">
              <div id="defaultdashboardAccessTree"></div>
              <input
                type="text"
                id="defaultdashboardAccessTree_validate"
                style={{ height: '1px', margin: '0', border: '0' }}
                name="s_defaultdashboardAccessTree_validate"
                required
              />
            </div>
            <input type="hidden" id="current_client" />
          </div>
        </div>
        <div className="modal-footer">
          <button
            className="btn-flat right btn-primary"
            style={{ width: '150px', textAlign: 'center', margin: '6px 0' }}
            onClick={() => {
              // @ts-ignore
              window.saveDashboards();
              setTimeout(() => {
                dispatch(loadAllClients('0'));
                dispatch(selectClient(undefined))
                toggleDashboardModal();
                clearSearch('');
              }, 1000);
            }}
          >
            Save
          </button>
          <button
            className=" modal-action modal-close btn-secondary btn-flat"
            onClick={() => {
              setTimeout(() => {
                dispatch(selectClient(undefined))
                toggleDashboardModal();
              }, 500);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function setupDashboardTrees(client, defaultDashboardId) {
  // @ts-ignore
  window.setupDefaultDashboardJsTree()
  // @ts-ignore
  window.modifyDashboards(defaultDashboardId, client);
}
